import { axios } from '@vyce/core/src/api';

import config from '../config';

const URL = `${config.storageApiUrl}`;

export const uploadFileRequest = (file: File) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);
  return axios.post(`${URL}/documents`, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadPassportRequest = (passport: File) => {
  const bodyFormData = new FormData();

  const fileToUpload = passport.type.startsWith('image/')
    ? passport
    : new File([passport], passport.name, { type: 'image/jpeg' });

  bodyFormData.append('file', fileToUpload);
  return axios.post(`${URL}/passport/scan`, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadSelfieRequest = (selfie: File) => {
  const bodyFormData = new FormData();
  const fileToUpload = selfie.type.startsWith('image/')
    ? selfie
    : new File([selfie], selfie.name, { type: 'image/jpeg' });

  bodyFormData.append('file', fileToUpload);

  return axios.post(`${URL}/passport/selfie`, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadProfilePhotoRequest = (photo: File) => {
  const bodyFormData = new FormData();

  const fileToUpload = photo.type.startsWith('image/')
    ? photo
    : new File([photo], photo.name, { type: 'image/jpeg' });

  bodyFormData.append('file', fileToUpload);

  return axios.post(`${URL}/profile-photos`, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
